/**
 * Render UTC timestamp from server.
 *
 * TODO: Relative time in some cases?
 * TODO: Is title attribute the desired tooltip UX?
 */
import moment from 'moment';
import React from 'react';

import {Tooltip} from './Tooltip';

type TimestampProps = {
  // Acceptable format: "2022-10-04T14:24:44"
  value: string;
};

// Return short and long formatted versions of the provided timestamp.
export const formatTimestamp = (value: string) => {
  // REF: https://momentjs.com/docs/#/displaying/format/
  const now = moment();
  const then = moment.utc(value, 'YYYY-MM-DDTHH:mm:ss').local();
  let format = 'MMM Do YYYY [at] h:mma';
  if (now.year() === then.year()) {
    format = 'MMM Do [at] h:mma';
  }
  return {
    // TODO: It would be nice if we could display a timezone string here to
    //       make it clear to the user this is local time. However, we don't have
    //       a reliable way to get it. We'd have to add a dependency on moment-timezone
    //       and then ask it to guess.
    //       REF: https://github.com/moment/moment/issues/162
    long: then.format('dddd, MMMM Do YYYY [at] h:mm:ss a'),
    short: then.format(format),
  };
};

export const Timestamp = ({value}: TimestampProps) => {
  const {long, short} = formatTimestamp(value);
  const text = <span>{short}</span>;
  return <Tooltip position="top center" content={long} trigger={text} />;
};
